module.exports = __webpack_public_path__ + "img/icon-line.3615f8f7.svg";